$(function(){
	$('.nsSlider').slick({
		accessibility: false,
        speed: 1500,
		autoplay: true,
        autoplaySpeed: 4000,
		arrows: false,
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		responsive: [{
			breakpoint: 899,　
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			}
		}]
	});
});